import { useFormContext } from 'react-hook-form';
import { IResetPasswordFormData } from '../../../domain/models/IResetPasswordFormData';

export function useResetPasswordFormContext() {
	return useFormContext<IResetPasswordFormData>();
}
